import { FeatureRoute } from '@/core/model/feature-route';

export const USER_ROUTER: FeatureRoute = {
    key: 'module.userManagement.manageUser',
    featureName: 'User Management',
    routerLink: 'user-management/user'
};
export const ROLE_ROUTER: FeatureRoute = {
    key: 'module.userManagement.manageRole',
    featureName: 'Role Maintenance',
    routerLink: 'user-management/role'
};

export const WORKFLOW_ONBOARDING: FeatureRoute = {
    key: 'module.onboarding.caseManagement',
    featureName: 'Onboarding',
    routerLink: 'case-workflow/onboarding'
};

export const WORKFLOW_WATCHLIST: FeatureRoute = {
    key: 'module.watchlist.caseManagement',
    featureName: 'Watchlist',
    routerLink: 'case-workflow/watchlist/case-management'
};

export const TRANSACTION_SCREENING_WORKFLOW: FeatureRoute = {
    key: 'module.trxScreening.caseManagement',
    featureName: 'Transaction Screening',
    routerLink: 'case-workflow/transaction-screening/case-management'
};

export const APPLICATION_SETTING: FeatureRoute = {
    key: 'module.setting.applicationSetting',
    featureName: 'Application Setting',
    routerLink: 'setting/application-setting'

}
export const APPLICATION_LICENSE: FeatureRoute = {
    key: 'module.setting.applicationLicense',
    featureName: 'Application License',
    routerLink: 'setting/application-license'

}
export const PARAMETER_SETTING: FeatureRoute = {
    key: 'module.setting.parameterSetting',
    featureName: 'Parameter Setting',
    routerLink: 'setting/parameter-setting'

}
export const MANAGE_ROLES: FeatureRoute = {
    key: 'module.userManagement.manageRoles',
    featureName: 'Manage Role',
    routerLink: 'user-management/manage-role'
}
export const EMAIL_TEMPLATE: FeatureRoute = {
    key: 'module.setting.emailTemplate',
    featureName: 'Email Template',
    routerLink: 'application-setting/email-template'

}
export const REMARK_TEMPLATE: FeatureRoute = {
    key: 'module.setting.remarkTemplate',
    featureName: 'Remark Template',
    routerLink: 'application-setting/remark-template'
};
export const MANAGE_BRANCH: FeatureRoute = {
    key: 'module.userManagement.manageBranch',
    featureName: 'Manage Branch',
    routerLink: 'user-management/branch'
};
export const USER_ACTIVITIES_LOG: FeatureRoute = {
    key: 'module.userManagement.userActivitiesLog',
    featureName: 'User Activities Log',
    routerLink: 'user-management/user-activities-log'
}
export const SETUP_WORKFLOW: FeatureRoute = {
    key: 'module.setting.workflow',
    featureName: 'Setup Workflow',
    routerLink: 'application-setting/setup-workflow'
};
export const APP_ROUTES = {
    USER: USER_ROUTER.routerLink,
    ROLE: ROLE_ROUTER.routerLink,
    ONBOARD_WORKFLOW: WORKFLOW_ONBOARDING.routerLink,
    WATCHLIST_WORKFLOW: WORKFLOW_WATCHLIST.routerLink,
    TRANSACTION_SCREENING_WORKFLOW: TRANSACTION_SCREENING_WORKFLOW.routerLink,
    APPLICATION_SETTING: APPLICATION_SETTING.routerLink,
    APPLICATION_LICENSE: APPLICATION_LICENSE.routerLink,
    PARAMETER_SETTING: PARAMETER_SETTING.routerLink,
    MANAGE_ROLES: MANAGE_ROLES.routerLink,
    EMAIL_TEMPLATE: EMAIL_TEMPLATE.routerLink,
    REMARK_TEMPLATE: REMARK_TEMPLATE.routerLink,
    MANAGE_BRANCH: MANAGE_BRANCH.routerLink,
    USER_ACTIVITIES_LOG: USER_ACTIVITIES_LOG.routerLink,
    SETUP_WORKFLOW: SETUP_WORKFLOW.routerLink,

} as const;
